const Constants = {
	HTTP_METHOD: {
		GET: "get",
		POST: "post",
		DELETE: "delete",
		PUT: "put",
		PATCH: 'patch'
	},

	CDN: {
		POPUP_IMAGE_BASE: "https://down.wjthinkbig.com/BOOKCLUB/SMARTALL-MID/POPUP",
		CARD_IMAGE_BASE: "https://down.wjthinkbig.com/BOOKCLUB/SMARTALL-MID/CARD",
		EVENT_IMAGE_BASE: "https://down.wjthinkbig.com/BOOKCLUB/SMARTALL-MID/EVENT",
	},

	// SERVER_DOMAIN: {
	//     VIDEO_PLAYER_DOMAIN: "https://web-public-viewer-video-dev.wjthinkbig.com",
	//     PDF_VIEWER_DOMAIN: "https://web-public-viewer-video-dev.wjthinkbig.com/",
	//     QST_VIEWER_DOMAIN: "https://web-public-viewer-question-dev.wjthinkbig.com:4430",
	//     GW_SMARTALL_MID_DOMAIN: "https://gw-smartall-mid-dev.wjthinkbig.com",
	//     SOKET_DOMAIN: "https://socket-public-boradcast-activity-dev.wjthinkbig.com",
	// },

	MID_STUDY_API: {
		TODAY_PPUP_INFO: "/midStudy/v1.0/common/ppupInfo/users/{MMBR_SEQ}",
		TODAY_CTGR_LIST: "/midStudy/v1.0/common/menus/{MENU_CD}/users/{MMBR_SEQ}", // 메뉴 리스트
		TODAY_CTGR_USER_LIST: "/midStudy/v1.0/today/ctgrTypes/{CTGR_TY}/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/classes",
		TODAY_CTGR_USER_CARD_LIST: "/midStudy/v1.0/today/days/{STD_DT}/users/{MMBR_SEQ}/cards",
		CLASS_CTGR_USER_CARD_LIST: "/midStudy/v1.0/class/ctgrTypes/{CTGR_TY}/ctgrCodes/{CTGR_CODE}/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/classes",
		COMMON_ADDT_LIST: "/midStudy/v1.0/class/ctgrTypes/{CTGR_TY}/ctgrCodes/{CTGR_CODE}/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/menus",
		TODAY_BNR_LIST: "/midStudy/v1.0/common/bnrList/gradCds/{GRAD_CD}/users/{MMBR_SEQ}",
		TODAY_BNR_LIST_SUBS: "/midStudy/v1.0/common/bnrList/gradCds/{GRAD_CD}/users/{MMBR_SEQ}/subscriberTypes/{SUBSCRIBER_TYPE}",
		//FORCE_TODAY_BNR_LIST_SUBS: "/midStudy/v1.0/common/bnrList/gradCds/{GRAD_CD}/users/{MMBR_SEQ}/subscriberTypes/{SUBSCRIBER_TYPE}?STD_DT={STD_DT}",
		STUDYROON_BNR_LIST: "/midStudy/v1.0/common/studyRoom/banner?PEDC_CD={PEDC_CD}",
		INIT_TMTBL_EVENT: "/midStudy/v1.0/schedule/mmbrInitEventPlan/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/aplDts/{APL_DT}",
		IQRY_SCHEDULE_HIST: "/midStudy/v1.0/schedule/mmbrStdTmtblApln/users/{MMBR_SEQ}",
		SAVE_SCHEDULE_YN_HIST: "/midStudy/v1.0/schedule/mmbrStdTmtblApln/users/{MMBR_SEQ}",
		GRADE_CODE_LIST: "/midStudy/v1.0/common/codeList/upCds/{UP_CD}",
		TCMT_LIST: "/midStudy/v1.0/common/tcmtList/courseCds/{COURSE_CD}/gradCds/{GRAD_CD}",
        INIT_EXAM_STD_TMTBL: "/midStudy/v1.0/schedule/initStudyPlan/users/{MMBR_SEQ}/gradCds/{GRAD_CD}",
        COURSE_PLAN_LIST : "/midStudy/v1.0/schedule/tmtbl/course/plan/types",
		SPECIAL_CLASS_SEARCH_INFO: "/midStudy/v1.0/class/ctgrTypes/{CTGR_TY}/ctgrCodes/{CTGR_CODE}/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/classes", // 전문관 정보 조회
		SPECIAL_CLASS_MENU_INFO: "/midStudy/v1.0/class/ctgrTypes/{CTGR_TY}/ctgrCodes/{CTGR_CODE}/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/menus", // 전문관 3Depth sub 검색 필터 조회
		CODE_LIST_INFO: "/midStudy/v1.0/common/codeList/upCds/{UP_CD}",
		POPUP_LIST: "/midStudy/v1.0/common/ppupList/users/{GRAD_CD}",
		CHAGNE_TEXTBOOK_POPUP_INFO: "/midStudy/v1.0/common/aatbppupinfo/users/{MMBR_SEQ}/gradCds/{GRAD_CD}",
		
		ENROLL_SCHOOL_POPUP_INFO: "/midStudy/v1.0/common/ppupInfo/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/aatbChgPopup", // (GET) 학교 및 교과서 정보 등록 팝업
		CHECK_COMPLELTE_CHANGE_SCHOOL: "/midStudy/v1.0/member/user/{MMBR_SEQ}/aatbChgComplete", //(PUT) 학교 교과서 변경 완료 여부 체크
		CHAGNE_SCHOOL_TEXTBOOK: "/midStudy/v1.0/schedule/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/mmbrSchlAatbChg", // (POST) 학교 교과서 변경
		SELECT_MEMBER_TIMETABLE: "/midStudy/v1.0/schedule/users/{MMBR_SEQ}/selectMmbrLastTmtbl", //(GET) 시간표 상태 조회

		// alltab 이용권 리스트 조회
		PEDC_LIST: "/midStudy/v1.0/member/user/{MMBR_SEQ}/pedcList?ALLTAB_YN=Y",

		// 진로진학
		STD_PLTF_TY_INFO: "/midStudy/v1.0/course/menu/stdPltfTyInfo", // 2Depth 메뉴 카테고리 조회
		STD_PLTF_CD_INFO: "/midStudy/v1.0/course/menu/pltfTys/{PLTF_TY}/stdPltfCdInfo", // 3Depth 메뉴 카테고리 조회
		STD_PLTF_CONTENTS_LIST: "/midStudy/v1.0/course/contentsList/pltfTys/{PLTF_TY}/pltfCds/{PLTF_CD}/sorts/{SORT}", // 콘텐츠 리스트 조회
		STD_PLTF_SCHL_LIST: "/midStudy/v1.0/course/pltfSchl/pltfSchlTyCds/{PLTF_SCHL_TY_CD}/pltfTys/{PLTF_TY}/pltfCds/{PLTF_CD}", // 입시정보 학교유형별 학교조회
		STD_PLTF_CONTENTS_DETAIL: "/midStudy/v1.0/course/contentsDetail/pltfInfoSeqs/{PLTF_INFO_SEQ}/pltfTys/{PLTF_TY}/pltfCds/{PLTF_CD}/pltfReltnCds/{PLTF_RELTN_CD}/mmbrSeqs/{MMBR_SEQ}", // 진로/진학 컨텐츠 상세 정보 조회
		STD_PLTF_CONTENTS_LIKE_CNT: "/midStudy/v1.0/course/contentsLikeCnt/pltfInfoSeqs/{PLTF_INFO_SEQ}/likeYn/{LIKE_YN}/mmbrSeqs/{MMBR_SEQ}", // 컨텐츠 좋아요 카운터 up
		// 자격증
		LICENSE_CLASS_MAIN_INFO: "/midStudy/v1.0/class/ctgrTypes/{CTGR_TY}/ctgrCodes/{CTGR_CD}/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/classes?PEDC_CD={PEDC_CD}",
		LICENSE_CLASS_SUB_INFO: "/midStudy/v1.0/class/ctgrTypes/{CTGR_TY}/ctgrCodes/{CTGR_CD}/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/classes?PEDC_CD={PEDC_CD}",
		// AI 독서실 이벤트
		AI_STUDY_HISTORY: "/midStudy/v1.0/brcs/mmbrBrcsEvnt/users/{MMBR_SEQ}",
		// LNB 관련
		DRAWER_INFO: "/midStudy/v1.0/common/drawerInfo/users/{MMBR_SEQ}?PEDC_CD={PEDC_CD}", // LNB 정보 불러오기
		EMPTY_NOTICE: "/midStudy/v1.0/mypage/mmbrNotiHst/users/{MMBR_SEQ}", // 알림함 비우기
		CHANGE_DRAWER_LIST_INDEX: "/midStudy/v1.0/common/drawerCustomize/users/{USER_SEQ}", // LNB 순서 변경하기
		PRGM_INFO: "/midStudy/v1.0/common/prgmInfo", // LNB 정보 가져오기
		GET_POPUP_INFO: "/midStudy/v1.0/common/examppupinfo/gradCds/{GRAD_CD}/subscriberTypes/{SUBSCRIBER_TYPE}", // 팝업 정보 가져오기
		//AI강의추천, 인기TOP강의
		AI_RCMD_CLASS: "/midStudy/v1.0/today/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/aiRcmnLecture",

		PERFORM_EXAM_LIST: "/midStudy/v1.0/backoffice/boardManage/prfmVltnGuide?sort={SORT}", // 수행평가 가이드
		PERFORM_EXAM_DETAIL: "/midStudy/v1.0/backoffice/boardManage/prfmVltnGuide/detail?seq={seq}", // 수행평가 가이드 상세 조회
		PERFORM_EXAM_LIKE_CHK: "/midStudy/v1.0/backoffice/boardManage/prfmVltnGuideLikedYn?tbPrfmVltnGuideSeq={seq}&mmbrSeq={mmbrSeq}", // 수행평가 가이드 좋아요 조회 / 수정
		
		IMPROVE_GRADES_POPUP_INFO: "/midStudy/v1.0/common/ppupInfo/users/{MMBR_SEQ}/eventPpupInfo", //(GET) 성적향상 프로젝트 이벤트 팝업 검색 정보

		// 이벤트 팝업 (팝업 노출여부를 서버에서 관리하는 경우 주로 사용)
		EVENT_POPUP_INFO: "/midStudy/v1.0/common/main/popup/users/{MMBR_SEQ}", // (GET) 이벤트 정보 조회
		EVENT_POPUP_SAVE: "/midStudy/v1.0/common/ppupInfo/users/{MMBR_SEQ}/ppupEventInsert", //(GET) 이벤트 팝업 노출여부 저장

		// 2024년 겨울방학 학습독려 이벤트 팝업
		WINTER_VACATION_EVENT_POPUP: "/midStudy/v1.0/common/ppupInfo/users/{MMBR_SEQ}/encourageStudyEvent?PEDC_CD={PEDC_CD}",

		// 시험대비
		PREV_MISS_PLAN_INFO : "/midStudy/v1.0/misPlan/users/{MMBR_SEQ}/prvMisPlanInfo", // (GET) 사전조회
		SEL_PLAN_MISS_STATUS: "/midStudy/v1.0/misPlan/users/{MMBR_SEQ}/planSeq/{PLAN_SEQ}/selPlanMisStatus", // (GET) 현황조회
		DAILY_VISIT_MISSION: "/midStudy/v1.0/misPlan/users/{MMBR_SEQ}/menuCd/{MENU_CD}/procDailyVisitMission", // (POST) 방문형 미션
		MISSION_PLAN_INFO: "/midStudy/v1.0/misPlan/users/{MMBR_SEQ}/planSeq/{PLAN_SEQ}/setMisPlanInfo", // (PUT) 사용자 미션 참여이력 저장
		PROC_EXAM_SCORE_INS_YN:
			"/midStudy/v1.0/misPlan/users/{MMBR_SEQ}/planSeq/{PLAN_SEQ}/procExamScoreInsYn", // (POST) 성적 입력 여부 처리 (body 없음)
	
		// 챗봇
		CHATBOT_DELIVERY_MESSAGES: "/midStudy/v1.0/chatBot/deliveryMessages/users/{MMBR_SEQ}", // 챗봇 배송 메시지
		PEDC_AUTH_CHECK: "/midStudy/v1.0/common/pedcAutrList/pedcCds/{PEDC_CD}?DVSN_CD={DVSN_CD}&STD_DT={STD_DT}", // 이용권별 권한 조회
	},

	CLASS_API: {
		CLASS_INFO: "/midStudy/v1.0/class/users/{MMBR_SEQ}/classInfo/{CLAS_SEQ}",
		CLASS_DETAIL_INFO: "/midStudy/v1.0/class/users/{MMBR_SEQ}/classDetail/{CLAS_SEQ}",
		CLASS_TEACHER_PROFILE: "/midStudy/v1.0/class/intrInfo/{CLAS_SEQ}",
		CLASS_VOD_EXAM_DESCRIPTION: "/midStudy/v1.0/tcmtvod/main/vodTabCheck/clasSeq/{CLAS_SEQ}",
		CLASS_VOD_EXAM_LIST: "/midStudy/v1.0/tcmtvod/main/vodList/tcmtSeq/{TCMT_SEQ}?mmbr_seq={MMBR_SEQ}",
		CLASS_VOD_EXPLANATION_HISTORY: "/midStudy/v1.0/tcmtvod/questionVideoShst/users/{MMBR_SEQ}/tcmtSeq/{TCMT_SEQ}/qstPageNo/{QST_PAGE_NO}/qstNo/{QST_NO}/{VD_STATUS}",
	},

	SEARCH_API: {
		CLASS_AUTO_COMPLETE: "/search/v1.0/samid/grads/{GRAD_CD}/pedic/{PEDC_CD}/users/{MMBR_SEQ}/clasAutoComplete",
		POPULAR_CLASS: "/search/v1.0/samid/grads/{GRAD_CD}/pedic/{PEDC_CD}/users/{MMBR_SEQ}/popularClas",
		SEARCH_CLASS: "/search/v1.0/samid/grads/{GRAD_CD}/pedic/{PEDC_CD}/users/{MMBR_SEQ}/searchClas",
		POPULAR_WORD: "/search/v1.0/samid/grads/{GRAD_CD}/pedic/{PEDC_CD}/users/{MMBR_SEQ}/popularWord",
		QUESTION_SEARCH: "/search/v1.0/samid/grads/{GRAD_CD}/pedic/{PEDC_CD}/users/{MMBR_SEQ}/courseCodes/{COURSE_CD}/tcmts/{TCMT_CD}/searchQstVdo",
		DICT_URL: "/midStudy/v1.0/common/upMenus/{UP_MENU_CD}/menus/{MENU_CD}/users/{MMBR_SEQ}",
		SEARCH_LIBRARY_BOOKS: "/midStudy/v1.0/class/ctgrTypes/{CTGR_TY}/ctgrCodes/{CTGR_CD}/users/{MMBR_SEQ}/SearchBook/?SEARCH_TYPE={SEARCH_TYPE}&WORD={WORD}&GRAD={GRAD}&START_IDX={START_IDX}" // (GET) 문학도서관 도서 검색
	},

	MYPAGE_API: {
		// mypage
		MMBR_INFO: "/midStudy/v1.0/mypage/mmbrInfo/users/{MMBR_SEQ}?PEDC_CD={PEDC_CD}",
		MMBR_CLAS_FVRT_LIST: "/midStudy/v1.0/mypage/mmbrClasFvrt/users/{MMBR_SEQ}",
		MMBR_LUG_INQ_LIST: "/midStudy/v1.0/mypage/mmbrLugInq/users/{MMBR_SEQ}?INQ_TY={INQ_TY}&FROM={FROM}&SIZE={SIZE}",
		//MMBR_INQ_CNDT_INFO: "/midStudy/v1.0/mypage/mmbrInq/courseGrpCds/{COURSE_GRP_CD}?CLAS_SEQ={CLAS_SEQ}",
		MMBR_INQ_CNDT_INFO: "/midStudy/v1.0/mypage/mmbrInq/cndt?MMBR_SEQ={MMBR_SEQ}&COURSE_GRP_CD={COURSE_GRP_CD}&CLAS_SEQ={CLAS_SEQ}&PEDC_CD={PEDC_CD}",
		MMBR_INQ_INFO: "/midStudy/v1.0/mypage/mmbrInq/inqSeqs/{INQ_SEQ}",
		MMBR_INQ_LIST: "/midStudy/v1.0/mypage/mmbrInq/users/{MMBR_SEQ}?COURSE_GRP_CD={COURSE_GRP_CD}&QST_YN={QST_YN}&FROM={FROM}&SIZE={SIZE}",
		MMBR_INQ_SAVE: "/midStudy/v1.0/mypage/mmbrInq/users/{MMBR_SEQ}",
		MMBR_INQ_DEL: "/midStudy/v1.0/mypage/mmbrInq/users/{MMBR_SEQ}/inqSeqs/{INQ_SEQ}",
		MMBR_CMN_INQ_LIST: "/midStudy/v1.0/mypage/mmbrCmnInq/users/{MMBR_SEQ}?INQ_DVSN_CD={INQ_DVSN_CD}&FROM={FROM}&SIZE={SIZE}",
		MMBR_CMN_INQ_DEL: "/midStudy/v1.0/mypage/mmbrCmnInq/users/{MMBR_SEQ}",
		MMBR_INIT_STUDY_PLAN: "/midStudy/v1.0/schedule/mmbrInitStudyPlan/users/{MMBR_SEQ}/gradCds/{GRAD_CD}",
		// noti
		MMBR_NOTI_HST_LIST: "/midStudy/v1.0/mypage/mmbrNotiHst/users/{MMBR_SEQ}?DSP_TY_CD={DSP_TY_CD}",
		MMBR_NOTI_HST_CUD: "/midStudy/v1.0/mypage/mmbrNotiHst/users/{MMBR_SEQ}",
		// note
		MMBR_NOTE_HST_CRUD: "/midStudy/v1.0/mypage/mmbrNoteHst/users/{MMBR_SEQ}",
		// init
		MMBR_PROFILE_INFO: "/midStudy/v1.0/member/mmbrPhtgInfo/users/{MMBR_SEQ}/phtgDvsnCds/{PHTG_DVSN_CD}",
		MMBR_PROFILE_SAVE: "/midStudy/v1.0/member/mmbrPhtgInfo/users/{MMBR_SEQ}",
		// schl
		MMBR_SCHLCDS_INFO: "/midStudy/v1.0/member/mmbrSchlCdsInfo/users/{MMBR_SEQ}",
		// aatb
		SCHL_AATB_LIST: "/midStudy/v1.0/common/aatbInfo/stdSchlCds/{STD_SCHL_CD}/gradCds/{GRAD_CD}?SMST_CD={SMST_CD}&COURSE_GRP_CD={COURSE_GRP_CD}&COURSE_ALL={COURSE_ALL}",
		GRAD_AATB_LIST: "/midStudy/v1.0/common/aatbInfo/gradCds/{GRAD_CD}?SMST_CD={SMST_CD}&COURSE_GRP_CD={COURSE_GRP_CD}",
		MMBR_AATB_LIST: "/midStudy/v1.0/common/mmbrAatbInfo/users/{MMBR_SEQ}/stdSchlCds/{STD_SCHL_CD}/gradCds/{GRAD_CD}?SMST_CD={SMST_CD}&COURSE_GRP_CD={COURSE_GRP_CD}",
		MMBR_AATB_LIST_SAVE: "/midStudy/v1.0/common/mmbrAatbInfo/users/{MMBR_SEQ}/gradCds/{GRAD_CD}",
		// fvrt
		CLASS_FAVORITE_CHANGE: "/midStudy/v1.0/mypage/favorite/users/{MMBR_SEQ}/class/{CLAS_SEQ}",
		CLASS_FAVORITE_CHANGE_ALL: "/midStudy/v1.0/mypage/favoriteSelect/users/{MMBR_SEQ}",    // 찜한강좌 일괄해제 할 때 사용
		MMBR_UPDATE_YN: "/midStudy/v1.0/member/selectMmbrAatbUpdYN/users/{MMBR_SEQ}/gradCds/{GRAD_CD}",
		//basic choose
		MMBR_BASIC_CHOOSE_INFO: "/midStudy/v1.0/member/mmbrBasicChooseInfo/users/{MMBR_SEQ}",
		MMBR_INIT_COURSE_STD_PLAN: "/midStudy/v1.0/schedule/initCourseStdPlanTemp/users/{MMBR_SEQ}/courseCode/MATH/gradCds/{GRAD_CD}/aplDt/20220410?TODAY={TODAY}",
		// 가지고 있는 이용권 목록
		PEDC_LIST_INQUIRY: "/midStudy/v1.0/member/user/{MMBR_SEQ}/pedcList",
		// 회원경고제도 (강좌 Q&A -> CLAS_QA | 문항오류신고 -> QST_QA)
		MMBR_LIMIT_YN: "/midStudy/v1.0/mypage/mmbrLmttInfo/users/{MMBR_SEQ}/reltnDvsnCd/{DVSN_CD}",
		
		MMBR_CALENDAR_CURRENT: "/midStudy/v1.0/schedule/users/tmtbl/std/courses?TODAY={TODAY}&MMBR_SEQ={MMBR_SEQ}", // 표준시간표+대표강좌리스트
		MMBR_CALENDAR_DETAIL: "/midStudy/v1.0/schedule/users/tmtbl/std/courses?TODAY={TODAY}&MMBR_SEQ={MMBR_SEQ}&DETAIL_YN=Y", // 표준시간표+대표강좌리스트 상세
		MMBR_CALENDAR_LIST: "/midStudy/v1.0/schedule/selecStdTmtblList/users/{MMBR_SEQ}/gradCds/{GRAD_CD}?MMBR_SEQ={MMBR_SEQ}&S_PEDC_CD={PEDC_CD}&TODAY={TODAY}", // 표준시간표조회 (POST)
		MMBR_CALENDAR_SAVE: "/midStudy/v1.0/schedule/users/tmtbl/representative/classes?MMBR_SEQ={MMBR_SEQ}&TODAY={TODAY}", // 회원대표강좌선택저장 (POST)

		// 시험기간 & 성적 입력
		EXAM_INFO_SAVE: "/midStudy/v1.0/member/user/{MMBR_SEQ}/exam/score",   // 시험기간 & 성적 등록
		EXAM_INFO_LIST: "/midStudy/v1.0/member/user/{MMBR_SEQ}/gradCds/{GRAD_CD}/exam/score?exam_dvsn_cd={EXAM_DVSN_CD}", // 시험기간&성적 조회
	},

	STUDY_PLAN_API: {
		CALENDAR_LIST: "/midStudy/v1.0/schedule/selectStudyPlanCalendar/users/{MMBR_SEQ}/aplDts/{APL_DT}?PEDC_GR_CD={PEDC_GR_CD}",
		CALENDAR_DAY_LIST: "/midStudy/v1.0/schedule/selectStudyPlanDay/users/{MMBR_SEQ}/aplDts/{APL_DT}?PEDC_GR_CD={PEDC_GR_CD}",
		STUDY_PLAN_CARD_LIST: "/midStudy/v1.0/schedule/selectStudyPlanMonthlyList/users/{MMBR_SEQ}/aplDts/{APL_DT}",
		STD_TMTLB_LIST: "/midStudy/v1.0/schedule/selecStdTmtblList/users/{MMBR_SEQ}/gradCds/{GRAD_CD}",
		SCHL_CD_LIST: "/midStudy/v1.0/common/selectSchlCdsList",
		SAVE_STUDY_PLAN: "/midStudy/v1.0/schedule/saveTimeTable/users/{MMBR_SEQ}/gradCds/{GRAD_CD}",
		CTGR_INFO_LIST: "/midStudy/v1.0/class/selectClasCtgrList/users/{MMBR_SEQ}",
		CLAS_INFO_LIST: "/midStudy/v1.0/class/selectClsCtgrLecList/users/{MMBR_SEQ}/ctgrTys/{CTGR_TY}/courseCodes/{COURSE_CODE}",
		MY_TIMETABLE_LIST: "/midStudy/v1.0/schedule/selectMmbrTimeTable/users/{MMBR_SEQ}",
		INIT_TIMETABLE_LIST: "/midStudy/v1.0/schedule/selectMmbrStdTimeTable/users/{MMBR_SEQ}/gradCds/{GRAD_CD}",
		ADD_STUDY_PLAN: "/midStudy/v1.0/schedule/users/{MMBR_SEQ}/tmtbl/classes",
		INIT_STUDY_PLAN: "/midStudy/v1.0/schedule/initStudyPlan/users/{MMBR_SEQ}/gradCds/{GRAD_CD}",
		MMBR_CLAS_CTGR_LIST: "/midStudy/v1.0/schedule/selectMmbrClasCtgrList/users/{MMBR_SEQ}",
		MMBR_CLAS_LIST: "/midStudy/v1.0/schedule/selectMmbrClasList/users/{MMBR_SEQ}/ctgrTys/{CTGR_TY}/ctgrCds/{CTGR_CD}/courseCodes/{COURSE_CODE}/gradCds/{GRAD_CD}",
		DELETE_MMBR_TMTBL_PLAN: "/midStudy/v1.0/schedule/deleteMmbrTmtblPlan/users/{MMBR_SEQ}/clasSeq/{CLAS_SEQ}/courseCode/{COURSE_CODE}",
		IS_PRIME: "/midStudy/v1.0/common/pedcGrCdList/?MMBR_SEQ={MMBR_SEQ}",
		PRIME_INIT_INFO: "/midStudy/v1.0/common/initData/pedc",
		PRIME_SCHL_INFO_MSG: "/midStudy/v1.0/schedule/users/{MMBR_SEQ}/pedcGrCd/{PEDC_GR_CD}",
		CALENDAR_WEEK_LIST: "/midStudy/v1.0/schedule/study/plan/week?MMBR_SEQ={MMBR_SEQ}&STR_DT={STR_DT}&END_DT={END_DT}",

		// 시험 조회
		CALENDAR_EXAM_DDAY : "/midStudy/v1.0/schedule/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/exam?type=ddays",
		CALENDAR_EXAM_MONTHLY_LIST : "/midStudy/v1.0/schedule/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/exam?type=month&month={YYYYMM}",
		CALENDAR_EXAM_WEEK_LIST : "/midStudy/v1.0/schedule/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/exam?type=week&str_dt={std_dt}&end_dt={end_dt}"
	},

	ABILITY_EXAM_API: {
		// 응시 가능한 진단평가 조회 (GET)
		AVAILABLE_EXAM: "/midStudy/v1.0/abilityExam/users/{MMBR_SEQ}/abilityExams/available?PEDC_CD={PEDC_CD}&GRAD_CD={GRAD_CD}&COURSE_CODE=MATH",
	},

	MISN_API: {
		MMBR_MISN_HST_LIST: "/midStudy/v1.0/misn/mmbrMisnHst/users/{MMBR_SEQ}/stdDts/{STD_DT}?ST_YN={ST_YN}",
	},

	LOUNGE_API: {
		// inq
		LUG_INQ_RPL_INFO: "/midStudy/v1.0/ageLug/lugInqConditionInfo/gradCds/{GRAD_CD}",
		LUG_EMG_INQ_INFO_LIST: "/midStudy/v1.0/ageLug/lugEmgInqInfo/gradCds/{GRAD_CD}",
		LUG_INQ_INFO_LIST:
			"/midStudy/v1.0/ageLug/lugInqInfoList/users/{MMBR_SEQ}?GRAD_CD={GRAD_CD}&SMST_CD={SMST_CD}&COURSE_GRP_CD={COURSE_GRP_CD}&PBCM_SEQ={PBCM_SEQ}&UNIT_SEQ={UNIT_SEQ}&TCHR_RPL_YN={TCHR_RPL_YN}&DSP_NMORD={DSP_NMORD}&SEARCH_WORD={SEARCH_WORD}&FROM={FROM}&SIZE={SIZE}",
		// rank
		LUG_MMBR_RPL_CNT: "/midStudy/v1.0/ageLug/lugMmbrRplInfo/users/{MMBR_SEQ}/yms/{YM}",
		LUG_RANK_INFO: "/midStudy/v1.0/ageLug/lugRankInfo/yms/{YM}/gradCds/{GRAD_CD}",
		// chat & write
		LUG_CHAT_INFO: "/midStudy/v1.0/ageLug/lugChatConditionInfo",
		LUG_INQ_INFO: "/midStudy/v1.0/ageLug/lugInqInfo/users/{MMBR_SEQ}?INQ_SEQ={INQ_SEQ}",
		LUG_INQ_INFO_SAVE: "/midStudy/v1.0/ageLug/lugInqInfo/users/{MMBR_SEQ}",
		LUG_INQ_INFO_DEL: "/midStudy/v1.0/ageLug/lugInqInfo/users/{MMBR_SEQ}/inqSeqs/{INQ_SEQ}",
		LUG_RPL_INFO: "/midStudy/v1.0/ageLug/lugRplInfo/users/{MMBR_SEQ}?INQ_SEQ={INQ_SEQ}",
		LUG_RPL_INFO_SAVE: "/midStudy/v1.0/ageLug/lugRplInfo/users/{MMBR_SEQ}",
		LUG_SUE_INFO_SAVE: "/midStudy/v1.0/ageLug/lugSueInfo/users/{MMBR_SEQ}",
		// limitInfo
		LUG_LIMIT_YN: "/midStudy/v1.0/ageLug/lugLmtYn/users/{MMBR_SEQ}/tyCd/{LMTT_TY_CD}?TODAY={TODAY}",

	},

	PLAYER_API: {
		STUDY_CONER: "/midStudy/v1.0/player/classes/{CLAS_SEQ}/lecs/{LEC_SEQ}/users/{MMBR_SEQ}/coners/{CONER_SEQ}/studyCorner",
		STUDY_CONTENTS_INFO: "/midStudy/v1.0/player/classes/{CLAS_SEQ}/lecs/{LEC_SEQ}/coners/{CONER_SEQ}/users/{MMBR_SEQ}/studyContentsInfo",
		STUDY_WRANSR_QST_INFO: "/midStudy/v1.0/player/wrAnsr/menus/{MENU_CD}/users/{MMBR_SEQ}/courseCds/{COURSE_CODE}/exams/{EXAM_SEQ}/wrAnsrQstInfo",
		STUDY_EXAM_INFO: "/midStudy/v1.0/player/stdTyDvsnCds/{STD_TY_DVSN_CD}/exams/{EXAM_SEQ}/users/{MMBR_SEQ}/examInfo",
		STUDY_TRIAL_EXAM_INFO: "/midStudy/v1.0/trialtest/exams/{EXAM_SEQ}/examInfo?MMBR_SEQ={MMBR_SEQ}",
		STUDY_EXAM_QST_INFO: "/midStudy/v1.0/player/stdTyDvsnCds/{STD_TY_DVSN_CD}/exams/{EXAM_SEQ}/users/{MMBR_SEQ}/examQstInfo",
		STUDY_AI_EXAM_INFO: "/midStudy/v1.0/player/stdTyDvsnCds/{STD_TY_DVSN_CD}/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/courseCds/{COURSE_CODE}/years/{YR}/smsts/{SMST_CD}/examDvsns/{EXAM_DVSN_CD}/examTimes/{EXAM_TIME}/aiExamInfo",
		STUDY_AI_EXAM_QST_INFO: "/midStudy/v1.0/player/stdTyDvsnCds/{STD_TY_DVSN_CD}/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/courseCds/{COURSE_CODE}/years/{YR}/smsts/{SMST_CD}/examDvsns/{EXAM_DVSN_CD}/examTimes/{EXAM_TIME}/aiExamQstInfo",
		STUDY_AI_REPORT_QST_INFO: "/midStudy/v1.0/player/users/{MMBR_SEQ}/courseCds/{COURSE_CODE}/gradCds/{GRAD_CD}/year/{YEAR}/smsts/{SMST_CD}/tcmtCd/{TCMT_DVSN_CD}/qstUnitSeq/{QST_UNIT_SEQ}/aiTcmtUnitQst",
		STUDY_ENGM_LIB: "/midStudy/v1.0/player/bookSeqs/{BOOK_SEQ}/coners/{CONER_SEQ}/users/{MMBR_SEQ}/bookContentsInfo", // 영어도서관 콘텐츠 정보조회
		STUDY_LITERATURE_LIB: "/midStudy/v1.0/player/bookSeqs/{BOOK_SEQ}/coners/{CONER_SEQ}/users/{MMBR_SEQ}/liBookContentsInfo", // (POST) 문학도서관 콘텐츠 정보 조회
		GET_CORNER_LIST: "/midStudy/v1.0/player/class/{CLAS_SEQ}/lec/{LEC_SEQ}/users/{MMBR_SEQ}/player", // 코너 정보 리스트 불러오기
		// 플레이어 정보 불러오기(POST)
		GET_PLAYER_INFO: "/midStudy/v1.0/player/stdTyDvsnCds/{STD_TY_DVSN_CD}/users/{MMBR_SEQ}/excutePlayerInfo",
		// 영어도서관 코너 정보 불러오기(GET)
		GET_ENGLISH_LIB_CORNER_LIST: "/midStudy/v1.0/player/book/{BOOK_SEQ}/users/{MMBR_SEQ}/player",
		// 문학도서관 코너 정보 불러오기(GET)
		GET_LITERATURE_CONTER_LIST: "/midStudy/v1.0/player/liBook/{BOOK_SEQ}/users/{MMBR_SEQ}/player",
		// 문항 오류 신고 (POST)
		// POST_WRONG_REPORT: "/midStudy/v1.0/player/qsts/{QST_CD}/users/{MMBR_SEQ}/sueQstInfo",
		POST_WRONG_REPORT: "/midStudy/v1.0/player/qsts/{QST_CD}/users/{MMBR_SEQ}/qstDvsnCd/{QST_DVSN_CD}/sueQstInfo",
		STUDY_RSBP_TEST_QST_INFO: "/midStudy/v1.0/rsbpTest/users/{MMBR_SEQ}/testSeq/{TEST_SEQ}/tsparSeq/{TSPAR_SEQ}/rsbpTestQstInfo", // 올백TEST 문항정보 조회
		GET_RSBP_TEST_REPORT_INFO: "/midStudy/v1.0/rsbpTest/users/{MMBR_SEQ}/courseCds/{COURSE_CODE}/gradCds/{GRAD_CD}/yr/{YEAR}/mon/{MONTH}/rsbpTestReportMmbrinfo", // 올백TEST 월간 분석 리포트 조회
		// 올백TEST 문항오류 신고
		POST_RSBP_TEST_WRONG_REPORT: "/midStudy/v1.0/player/qsts/{QST_CD}/users/{MMBR_SEQ}/qstDvsnCd/{QST_DVSN_CD}/rsbpSueQstInfo"
	},

	HISTORY_API: {
		SAVE_SHST: "/midStudy/v1.0/history/study/users/{MMBR_SEQ}/courses/{COURSE_CODE}/classes/{CLAS_SEQ}/lecs/{LEC_SEQ}/coners/{CONER_SEQ}",
		SAVE_QST_ANSR: "/midStudy/v1.0/history/qstAnsr/users/{MMBR_SEQ}/courses/{COURSE_CODE}/classes/{CLAS_SEQ}/lecs/{LEC_SEQ}/coners/{CONER_SEQ}/qsts/{QST_CD}",
		SAVE_QST_WRANSR: "/midStudy/v1.0/history/wrAnsr/menus/{MENU_CD}/users/{MMBR_SEQ}/courses/{COURSE_CODE}/exams/{EXAM_SEQ}/qsts/{QST_CD}",
		SAVE_EXAM_QST_ANSR: "/midStudy/v1.0/history/examQstAnsr/stdTyDvsnCds/{STD_TY_DVSN_CD}/users/{MMBR_SEQ}/exams/{EXAM_SEQ}/qsts/{QST_CD}",
		SAVE_VOD_SAVE: "/midCollect/v1.0/history/vod/std/users/{MMBR_SEQ}/courses/{COURSE_CODE}/classes/{CLAS_SEQ}/lecs/{LEC_SEQ}/coners/{CONER_SEQ}/hst", // 개념영상 시청 이력
		SAVE_VOD_POPUP_SAVE: "/midCollect/v1.0/history/vod/qst/users/{MMBR_SEQ}/qsts/{QST_CD}/hst", // 문항 해설영상 시청이력
		SAVE_MENU_CONNECT_RECORD: "/midCollect/v1.0/history/menu/users/{MMBR_SEQ}/hst", // 메뉴접속이력
		SAVE_AI_EXAM_QST_ANSR: "/midStudy/v1.0/history/aiExamQstAnsr/stdTyDvsnCds/{STD_TY_DVSN_CD}/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/courseCds/{COURSE_CODE}/years/{YR}/smsts/{SMST_CD}/examDvsns/{EXAM_DVSN_CD}/examTimes/{EXAM_TIME}/qsts/{QST_CD}",//AI추천문항 이동 및 채점
		SAVE_AI_REPORT_QST_ANSR: "/midStudy/v1.0/history/users/{MMBR_SEQ}/courseCds/{COURSE_CODE}/gradCds/{GRAD_CD}/year/{YEAR}/smsts/{SMST_CD}/tcmtCd/{TCMT_DVSN_CD}/qstUnitSeq/{QST_UNIT_SEQ}/qsts/{QST_CD}",//AI리포트추천문항 이동 및 채점
		SAVE_ENGM_LIB_SHST: "/midStudy/v1.0/history/enBookStudy/users/{MMBR_SEQ}/coners/{CONER_SEQ}/books/{BOOK_SEQ}", // 영어도서관 학습이력 저장
		SAVE_ENGM_LIB_ANSR: "/midStudy/v1.0/history/enBookStudy/qstAnsr/users/{MMBR_SEQ}/books/{BOOK_SEQ}/coners/{CONER_SEQ}/qsts/{QST_CD}",
		SAVE_LITERATURE_LIB_SHST: "/midStudy/v1.0/history/liBookStudy/users/{MMBR_SEQ}/coners/{CONER_SEQ}/books/{BOOK_SEQ}", // (POST) 문학도서관 학습이력 저장
		SAVE_RSBP_TEST_QST_APPLY: "/midStudy/v1.0/rsbpTest/users/{MMBR_SEQ}/testSeq/{TEST_SEQ}/tsparSeq/{TSPAR_SEQ}/qsts/{QST_CD}/rsbpTestQstApply", // 올백TEST 학습이력 저장
	},

	TESTLUG_API: {
		//2020.11 통합 API 추가
		TESTLUG_CATE_LIST: "/midStudy/v1.0/testLug/menus/{MENU_CD}/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/courseCds/{COURSE_CD}/classes/{CLASS_SEQ}/ctgrInfo",
		TESTLUG_TEST_LIST: "/midStudy/v1.0/testLug/menus/{MENU_CD}/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/courseCds/{COURSE_CD}/classes/{CLASS_SEQ}/testInfo",
		WANT_CATE_LIST: "/midStudy/v1.0/testLug/wrAnsr/menus/{MENU_CD}/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/courseCds/{COURSE_CD}/classes/{CLASS_SEQ}/ctgrInfo",
		WANT_TEST_LIST: "/midStudy/v1.0/testLug/wrAnsr/menus/{MENU_CD}/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/courseCds/{COURSE_CD}/classes/{CLASS_SEQ}/testInfo",
		// 문항 초기화: 쌍둥이/유사/한수준위 응시 중단한 케이스일 때, 문제은행 서비스를 메타수학에서 에듀베이스로 재설정
		RESET_PREV_EDU_SERVICE: "/midStudy/v1.0/testLug/users/{MMBR_SEQ}/coners/{CONER_SEQ}/courseCds/{COURSE_CODE}/deleteTestInfo?TEST_TYPE={TEST_TYPE}",

		// TEST라운지>모의고사
		TRIAL_TEST_CATEGORY: "/midStudy/v1.0/trialtest/gradCds/{GRAD_CD}/yr/{YR}/ctgrInfo?PEDC_CD={PEDC_CD}", // (GET) 모의고사 카테고리 조회
		TRIAL_TEST_LIST: "/midStudy/v1.0/trialtest/gradCds/{GRAD_CD}/courseCds/{COURSE_CD}/yr/{YR}/dgre/{DGRE}/testList?PEDC_CD={PEDC_CD}&MMBR_SEQ={MMBR_SEQ}", // (GET) 모의고사 목록 조회
		TRIAL_TEST_INFO: "/midStudy/v1.0/trialtest/testInfo?PEDC_CD={PEDC_CD}&MMBR_SEQ={MMBR_SEQ}", // (GET) 모의고사 정보 조회

		// 성적분석리포트
		EXAM_REPORT_INFO: "/midStudy/v1.0/trialtest/users/{MMBR_SEQ}/exams/{EXAM_SEQ}/reportStareInfo", // (GET) 성적분석리포트 정보 조회
		EXAM_REPORT_CONFIRM: "/midStudy/v1.0/trialtest/users/{MMBR_SEQ}/exams/{EXAM_SEQ}/reportConfirmUpd", // (GET) 성적분석리포트 사용자 확인 여부

		// 올백TEST
		ALL_BACK_TEST_CATEGORY: '/midStudy/v1.0/rsbpTest/gradCds/{GRAD_CD}/courseCds/{COURSE_CD}/examYn/{EXAM_YN}/users/{MMBR_SEQ}/ctgrInfo', // (GET) 올백TEST 카테고리 조회
		ALL_BACK_LIST: '/midStudy/v1.0/rsbpTest/gradCds/{GRAD_CD}/courseCds/{COURSE_CD}/examYn/{EXAM_YN}/users/{MMBR_SEQ}/testList', // (GET) 올백TEST 시험 리스트 조회
		ALL_BACK_WRONG_SQM: '/midStudy/v1.0/rsbpTest/users/{MMBR_SEQ}/testSeq/{TEST_SEQ}/tsparSeq/{TSPAR_SEQ}/rsbpWrongSqmGenerate', // (POST) 오답유사 문항 추가 조회

		UNIT_FILTER_LIST: "/midStudy/v1.0/qstb/rvsnYr/{RVSN_YR}/gradCds/{GRAD_CD}/courseCds/{COURSE_CD}/searchUnitInfo", // (GET) 단원 필터 조회
		UNIT_INFO_LIST: "/midStudy/v1.0/qstb/rvsnYr/{RVSN_YR}/gradCds/{GRAD_CD}/courseCds/{COURSE_CD}/searchQstbUnitList", // (GET) 단원 정보 조회
		UNIT_QSTB_LIST: "/midStudy/v1.0/qstb/user/{MMBR_SEQ}/courseSeq/{QSTB_COURSE_SEQ}/unitSeq/{QSTB_UNIT_INFO_SEQ}/searchQstbShstList", // (GET) 단원별 강의 조회
		WR_UNIT_INFO_LIST: "/midStudy/v1.0/qstb/user/{MMBR_SEQ}/rvsnYr/{RVSN_YR}/gradCds/{GRAD_CD}/courseCds/{COURSE_CD}/searchQstbWrUnitList", // (GET) 단원 정보 조회(오답노트)
		WR_UNIT_QSTB_LIST: "/midStudy/v1.0/qstb/user/{MMBR_SEQ}/courseSeq/{QSTB_COURSE_SEQ}/unitSeq/{QSTB_UNIT_INFO_SEQ}/schQstbWrTestList", // (GET) 단원별 강의 조회(오답노트)
	},

	MEMBERSHIP_API: {
		UPDATE_GRAD: "/membership/v1.0/samid/users/{MMBR_SEQ}/chgGrads",
		MMBR_INFO_LIST: "/membership/v1.0/samid/memberList?MMBR_SEQ_LIST={MMBR_SEQ_LIST}", //1,2,3,4
		MEMBERSHIP_INFO: "/membership/v1.0/samid/members/{MMBR_ID}",
		MEMBERSHIP_INFOV2: "/membership/v1.0/samid/memberInfo",
		MMBR_TYPE: "/membership/v1.0/samid/memberInfo/users/{MMBR_SEQ}",
		MEMBERSHIP_PAUSE_INFO: "/membership/v2.0/samid/user/{MEMBER_CODE}/pauseInfo",
	},

	STARSHOP_API: {
		MY_POINT: "/midStudy/v1.0/starshop/starPoints/{CUSTOMER_NUMBER}",
		PRODUCT_LIST: "/midStudy/v1.0/starshop/productList",
		POINT_HISTORY_LIST: "/midStudy/v1.0/starshop/history/{SERVICE_TYPE}/members/{CUSTOMER_NUMBER}?MIN_DATE={MIN_DATE}&MAX_DATE={MAX_DATE}",
		SET_GOALS: "/smartall/v1.0/starshop/targetProduct",
		GET_TARGET_PRODUCT: "/smartall/v1.0/starshop/targetProduct/contracts/{CONTRACT_NUMBER}/members/{CUSTOMER_NUMBER}",
		DELETE_TARGET_PRODUCT: "/smartall/v1.0/starshop/purposeProduct/members/{CUSTOMER_NUMBER}",
		EXCHANGE_PRODUCT: "/reward/v2.0/useReward/contracts/{CONTRACT_NUMBER}/members/{CUSTOMER_NUMBER}/services/{SERVICE_TYPE}/prodCodes/{REWORD_CODE}",
		EXCHANGE_HISORY: "/reward/v2.0/rewardOrder/contracts/{CONTRACT_NUMBER}/members/{CUSTOMER_NUMBER}?in_pagenum=1&in_mindate={MIN_DATE}&in_maxdate={MAX_DATE}",
		RESEND_PRODUCT: "/reward/v2.0/reSendCoupon/contracts/{CONTRACT_NUMBER}/members/{CUSTOMER_NUMBER}/orderNo/{ORDER_NO}/rewardcodes/{REWARD_CODE}",
	},

	CSBOARD_API: {
		ANOUN_LIST: "/midStudy/v1.0/member/csboard/anounList?SEARCH_TYPE={SEARCH_TYPE}&KEY_WORD={KEY_WORD}&FROM={FROM}&SIZE={SIZE}",
		ANOUN_DETAILED: "/midStudy/v1.0/member/csboard/anounDetailed?ANOUN_SEQ={ANOUN_SEQ}",
		FAQ_LIST: "/midStudy/v1.0/member/csboard/faqList?SEARCH_TYPE={SEARCH_TYPE}&KEY_WORD={KEY_WORD}",
		GET_TERMS_CONDITiONS: "/midStudy/v1.0/member/csboard/latelyTermsInfo?DVSN_CD={DVSN_CD}",
		MTRL_CONDITiONS: "/midStudy/v1.0/member/stdMtrl/ctgrTys/{CTGR_TY}/ctgrCds/{CTGR_CD}/gradCds/{GRAD_CD}/mmbrSeqs/{MMBR_SEQ}/mtrlDvsnCds/{MTRL_DVSN_CD}/clasSeqs/{CLAS_SEQ}/ctgrInfo",
		MTRL_LIST: "/midStudy/v1.0/member/stdMtrl/ctgrTys/{CTGR_TY}/ctgrCds/{CTGR_CD}/gradCds/{GRAD_CD}/courseGrpCds/{COURSE_GRP_CD}/stdMtrlTite/{STD_MTRL_TITE}/mmbrSeqs/{MMBR_SEQ}/mtrlDvsnCds/{MTRL_DVSN_CD}/clasSeqs/{CLAS_SEQ}/mtrlInfo",
		MTRL_FILE_INFO: "/midStudy/v1.0/member/stdMtrl/mtrlSeq/{STD_MTRL_SEQ}/mmbrSeqs/{MMBR_SEQ}/mtrlFileInfo",
		MTRL_MMBR_MPNG: "/midStudy/v1.0/member/stdMtrl/stdMtrLSeqs/{STD_MTRL_SEQ}/atacFileSeqs/{ATAC_FILE_SEQ}/mmbrSeqs/{MMBR_SEQ}/mmbrMtrlMpng",
	},

	BRCS_API: {
		BRCS_INFO: "/midStudy/v1.0/brcs/onlineBrcs/users/{MMBR_SEQ}",
		BRCS_ENTER: "/midStudy/v1.0/brcs/onlineBrcs/users/{MMBR_SEQ}/hst"
	},

	MYSTUDY_API: {
		DAY_STATE: ["/midStudy/v1.0/history/currDailyStat/days/{DAYS}/users/{MMBR_SEQ}"],
		WEEK_STATE: [
			"/midStudy/v1.0/history/currWeeklyStat/days/{DAYS}/users/{MMBR_SEQ}?COURSE_YN=Y",
			"/midStudy/v1.0/history/currWeeklyPlanStudyStat/days/{DAYS}/users/{MMBR_SEQ}",
			"/midStudy/v1.0/history/currWeeklyDays/days/{DAYS}",
		],
		TOT_STATE: [
			"/midStudy/v1.0/history/currMonthlyStat/days/{DAYS}/users/{MMBR_SEQ}",
			"/midStudy/v1.0/history/currMonthlyStatByDay/days/{DAYS}/users/{MMBR_SEQ}",
			"/midStudy/v1.0/history/currMonthlyStatByMonth/days/{DAYS}/users/{MMBR_SEQ}?MONTHS=4",
			"/midStudy/v1.0/history/currMonthlyStat/days/{DAYS}/users/{MMBR_SEQ}/testInfo",
			"/midStudy/v1.0/history/currMonthlyStat/days/{DAYS}/users/{MMBR_SEQ}/courses/{COURSE_CODE}/unitTestInfo",
			"/midStudy/v1.0/history/currMonthlystat/days/{DAYS}/users/{MMBR_SEQ}/testReport",
			// "/midStudy/v1.0/history/currMonthlystat/days/{DAYS}/users/343/testReport",
		],
	},

	// 교과서올집
	ALLZIP_API: {
		GET_SUBJECT: '/midStudy/v1.0/allZip/ctgr/courseTapList',
		GET_RVSN_YR: '/midStudy/v1.0/allZip/ctgr/rvsnYrList/courseGrpCds/{COURSE_GRP_CDS}',
		GET_GRADE: "/midStudy/v1.0/allZip/ctgr/gradCdList/courseGrpCds/{COURSE_GRP_CDS}/rvsnYr/{RVSN_YR}",
		GET_LOWER_SUBJECT: '/midStudy/v1.0/allZip/ctgr/courseCodeList/courseGrpCds/{COURSE_GRP_CDS}/grad_Cds/{GRAD_CD}/rvsnYr/{RVSN_YR}',
		GET_PUBLISHER: "/midStudy/v1.0/allZip/ctgr/pbcmList/courseGrpCds/{COURSE_GRP_CDS}/grad_Cds/{GRAD_CD}/courseCodes/{COURSE_CODES}",
		GET_UPPER_UNIT: "/midStudy/v1.0/allZip/ctgr/unit/aatbUnitMstSeqs/{AATB_UNIT_MST_SEQS}",
		GET_LIST: "/midStudy/v1.0/allZip/list/unit/aatbUnitMstSeqs/{AATB_UNIT_MST_SEQ}/aatbUnitSeqs/{AATB_UNIT_SEQ}",
		GET_SELECTED_PBCM: "/midStudy/v1.0/allZip/mmbrAatbInfo/users/{MMBR_SEQ}/stdSchlCds/ALL/gradCds/{GRAD_CD}", // 20230515 수정
		VIEW_COUNT_UP: "/midStudy/v1.0/allZip/unit/brwsCnt/aatbUnitSeqs/{AATB_UNIT_SEQ}/fileSeqs/{AATB_UNIT_ATAC_FILE_SEQ}/mmbrSeqs/{MMBR_SEQ}",
	},

	LIVEQNA_API: {
		USE_SERVICE_INFO: "/midStudy/v1.0/rltm/guide/stdRltmInqInfo/gradCds/{GRAD_CD}",
		GRAD_CD_LIST: "/midStudy/v1.0/rltm/gradCdList",
		COURSE_CD_LIST: "/midStudy/v1.0/rltm/courseCodeList",
		PBCM_CD_LIST: "/midStudy/v1.0/rltm/pbcmList/gradCds/{GRAD_CD}/smstCds/{SMST_CD}/courseCodes/{COURSE_CODE}",
		CHATTING_LIST: "/midStudy/v1.0/rltm/mmbr/stdRltmInqInfo/mmbrSeqs/{MMBR_SEQ}/rltmInqEvntSeqs/{RLTM_INQ_EVNT_SEQ}/gradCds/{GRAD_CD}",
		INSERT_NEW_CNTT: "/midStudy/v1.0/rltm/mmbr/saveRltmInqInfo/user/{MMBR_SEQ}/rltmInqEvntSeqs/{RLTM_INQ_EVNT_SEQ}/gradCds/{GRAD_CD}/courseCode/{COURSE_CODE}/pbcmSeq/{PBCM_SEQ}/aatbSeq/{AATB_SEQ}",
		REMAIN_QST_INFO: "/midStudy/v1.0/rltm/mmbr/stdRltmInqRemaNumInfo/user/{MMBR_SEQ}/rltmInqEvntSeqs/{RLTM_INQ_EVNT_SEQ}",
		RLTM_USE_YN: "/midStudy/v1.0/rltm/mmbr/rltmUseYn/rltmInqSeqs/{RLTM_INQ_SEQ}/gradCds/{GRAD_CD}",
	},

	AI_QUESTION_API: {
		SERVICE_PROVIDE_PERIOD: "/midStudy/v1.0/testLug/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/examPridInfo",
		AI_REPORT_INFO: "/midStudy/v1.0/testLug/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/courseCds/{COURSE_CODE}/years/{YR}/smsts/{SMST_CD}/examDvsns/{EXAM_DVSN_CD}/examAiReport",
		RECOMMEND_QUESTION: "/midStudy/v1.0/testLug/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/courseCds/{COURSE_CODE}/years/{YR}/smsts/{SMST_CD}/examDvsns/{EXAM_DVSN_CD}/aiRcmnQstSet",
		FINAL_TEST: "/midStudy/v1.0/testLug/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/courseCds/{COURSE_CODE}/years/{YR}/smsts/{SMST_CD}/examDvsns/{EXAM_DVSN_CD}/aiPrepareExam",
	},
	
	ENGLISH_VOCA_API: {
		// 영어보카 스텝 정보 조회
		STEP_INFO: "/midStudy/v1.0/voca/vocaPgmStpInfo/enVocaPgmSeqs/{EN_VOCA_PGM_SEQ}/enVocaStp/{EN_VOCA_STP}/scrnMoveDvsn/{SCRN_MOVE_DVSN}/mmbrSeqs/{MMBR_SEQ}",
		// 영어보카 교과서별 어휘 메뉴 화면이동 정보 조회(교과서 선택 or 단원선택)
		AATB_SCREEN_INFO: "/midStudy/v1.0/voca/aatb/aatbScrnOpt/mmbrSeqs/{MMBR_SEQ}/yr/{YR}/gradCds/{GRAD_CD}",
		// 영어보카 교과서별 어휘 전체 학년 리스트 조회
		AATB_GRAD_LIST: "/midStudy/v1.0/voca/aatb/gradList",
		// 영어보카 교과서별 어휘 학년별 출판사(교과서) 리스트 조회
		AATB_PBCM_LIST: "/midStudy/v1.0/voca/aatb/pbcmList/mmbrSeqs/{MMBR_SEQ}/yr/{YR}/gradCds/{GRAD_CD}",
		// 영어보카 교과서별 어휘 교재 단원정보 리스트 조회
		AATD_TCMT_UNIT_LIST: "/midStudy/v1.0/voca/aatb/tcmtUnitList/mmbrSeqs/{MMBR_SEQ}/aatbSeqs/{AATB_SEQ}",
		// 영어보카 스텝 리스트 조회
		STEP_LIST: "/midStudy/v1.0/voca/vocaStpList/enVocaPgmSeq/{EN_VOCA_PGM_SEQ}/mmbrSeqs/{MMBR_SEQ}",
		// 영어보카 스텝별 퀴즈 정보 조회
		STEP_QUESTION_LIST: "/midStudy/v1.0/voca/vocaPgmStpInfo/enVocaPgmSeqs/{EN_VOCA_PGM_SEQ}/enVocaStp/{EN_VOCA_STP}/scrnMoveDvsn/{SCRN_MOVE_DVSN}/mmbrSeqs/{MMBR_SEQ}",
		// 영어보카 퀴즈 단건 정보 조회
		SOLO_QUESTION: "/midStudy/v1.0/voca/vocaPgmStpQuizInfo/enVocaPgmSeqs/{EN_VOCA_PGM_SEQ}/enVocaStp/{EN_VOCA_STP}/enVocaQuizSeq/{EN_VOCA_QUIZ_SEQ}/mmbrSeqs/{MMBR_SEQ}",
		// 영어보카 프로그램학습이력 저장(POST) 
		SAVE_VOCA_HIST: "/midStudy/v1.0/voca/vocaPgmShst/mmbrSeqs/{MMBR_SEQ}/enVocaPgmSeqs/{EN_VOCA_PGM_SEQ}/enVocaStps/{EN_VOCA_STP}/stdPrgsSts/{STD_PRGS_ST}",
		// 영어보카 중학필수 어휘 일정 리스트 조회
		SCHEDULE_LIST: "/midStudy/v1.0/voca/essnt/enVocaScdul/mmbrSeqs/{MMBR_SEQ}/toDays/{TO_DAY}",
		// 영어보카 학습정보 조회
		ENGLISH_VOCA_INFO: "/midStudy/v1.0/voca/corner/vocaPgmInfo/mmbrSeqs/{MMBR_SEQ}/enVocaPgmSeqs/{EN_VOCA_PGM_SEQ}",
		// 기초 어휘 문항 조회
		BASIC_VOCA_PLAYER_INFO: "/midStudy/v1.0/voca/corner/vocaPgmInfo/mmbrSeqs/{MMBR_SEQ}/enVocaPgmSeqs/{EN_VOCA_PGM_SEQ}?RVW_DAY_YN={USE_RVW_YN}",
		// 고등 영어보카 조회
		HIGH_ENGLISH_VOCA_INFO: "/midStudy/v1.0/voca/highCore/pgmInfo/mmbrSeqs/{MMBR_SEQ}",
		// 기초 어휘 리스트 조회
		BASIC_VOCA_INFO: "/midStudy/v1.0/voca/midBasic/pgmInfo/mmbrSeqs/{MMBR_SEQ}",
	},

	LOG_API: {
		ERROR_EXCEPTION: '/membership/v1.0/samid/errorException/serials/{SERIAL_NO}',
	},
	
	REFERENCE_ROOM_API: {
		// 하위 카테고리 조회
		GET_CATEGORY_LIST: "/midStudy/v1.0/member/stdMtrl/ctgrTys/{CTGR_TY}/ctgrCds/{CTGR_CD}/gradCds/{GRAD_CD}/mmbrSeqs/{MMBR_SEQ}/mtrlDvsnCds/{MTRL_DVSN_CD}/clasSeqs/{CLAS_SEQ}/ctgrInfo?PEDC_CD={PEDC_CD}",
		// 학습자료실 조회
		GET_FILE_LIST: "/midStudy/v1.0/member/stdMtrl/ctgrTys/{CTGR_TY}/ctgrCds/{CTGR_CD}/gradCds/{GRAD_CD}/courseGrpCds/{COURSE_GRP_CD}/stdMtrlTite/{STD_MTRL_TITE}/mmbrSeqs/{MMBR_SEQ}/mtrlDvsnCds/{MTRL_DVSN_CD}/clasSeqs/{CLAS_SEQ}/mtrlInfo?PEDC_CD={PEDC_CD}&PAGE_SIZE={PAGE_SIZE}&PAGE_CNT={PAGE_CNT}",
		// 강좌상세>학습자료실 조회
		GET_CLASS_DETAIL_FILE_LIST: "/midStudy/v1.0/member/stdMtrl/ctgrTys/{CTGR_TY}/ctgrCds/{CTGR_CD}/gradCds/{GRAD_CD}/courseGrpCds/{COURSE_GRP_CD}/stdMtrlTite/{STD_MTRL_TITE}/mmbrSeqs/{MMBR_SEQ}/mtrlDvsnCds/{MTRL_DVSN_CD}/clasSeqs/{CLAS_SEQ}/mtrlInfo?PEDC_CD={PEDC_CD}&ORDER_SEQ={ORDER_SEQ}",
		// 첨부파일 조회
		GET_MTRL_FILE_LIST: "/midStudy/v1.0/member/stdMtrl/mtrlSeq/{MTRL_SEQ}/mmbrSeqs/{MMBR_SEQ}/myPageYn/{MY_PAGE_YN}/mtrlFileInfo/?PEDC_CD={PEDC_CD}",
		// 사용자 학습자료 선택정보 저장(POST)
		SAVE_MTRL_FILE: "/midStudy/v1.0/member/stdMtrl/stdMtrLSeqs/{STD_MTRL_SEQ}/atacFileSeqs/{ATAC_FILE_SEQ}/mmbrSeqs/{MMBR_SEQ}/saveMmbrMtrlMpng?PEDC_CD={PEDC_CD}",
		// 사용자 학습자료 선택시 저장여부 체크
		CHECK_MTRL_FILE: "/midStudy/v1.0/member/stdMtrl/stdMtrLSeqs/{STD_MTRL_SEQ}/atacFileSeqs/{ATAC_FILE_SEQ}/mmbrSeqs/{MMBR_SEQ}/checkMmbrMtrlMpng?PEDC_CD={PEDC_CD}",
		// 사용자 학습자료 삭제(DELETE)
		DELETE_MTRL_FILE: "/midStudy/v1.0/member/stdMtrl/stdMtrLSeqs/{STD_MTRL_SEQ}/atacFileSeqs/{ATAC_FILE_SEQ}/mmbrSeqs/{MMBR_SEQ}/delMmbrMtrlMpng?PEDC_CD={PEDC_CD}",
	},

	MUSIC_API: {
		//열공뮤직 카테고리 조회
		GET_CTGR_LIST: "/midStudy/v1.0/msic/ctgrList",
		//열공뮤직 컨텐츠 리스트 조회
		GET_CONTENTS_LIST: "/midStudy/v1.0/msic/cttsList/courseGrpCd/{COURSE_GRP_CD}/sorts/{SORT}/mmbrSeqs/{MMBR_SEQ}",
		//열공뮤직 컨텐츠 상세 정보 조회
		GET_CONTENTS_DETAIL: "/midStudy/v1.0/msic/cttsDetail/msicInfoSeq/{MSIC_INFO_SEQ}/mmbrSeqs/{MMBR_SEQ}",
		//열공뮤직 컨텐츠 좋아요
		GET_CONTENTS_LIKE: "/midStudy/v1.0/msic/cttsLikeCnt/msicInfoSeq/{MSIC_INFO_SEQ}/mmbrSeqs/{MMBR_SEQ}/likeYn/{LIKE_YN}",
	},

	CURRICULUM_API: {
		GET_MYPAGE_INFO: "/midStudy/v1.0/mypage/users/{MMBR_SEQ}/aiRcmnCrcm",
	},

	EVALUATION_API: {
		GET_REPORT_INFO: "/midStudy/v1.0/testLug/stdTyDvsnCds/{STD_TY_DVSN_CD}/exams/{EXAM_SEQ}/users/{MMBR_SEQ}/examResultCardInfo",
	},

	ENGLISH_LIBRARY_API: {
		GET_BOOKLIST: "/midStudy/v1.0/class/ctgrTypes/ENGLIB/ctgrCodes/ENGLIB/users/{MMBR_SEQ}/lvl/{BOOK_LVL_CD}/prgs/{STD_PRGS_ST}/book?PEDC_CD={PEDC_CD}&START_IDX={START_IDX}",
	},

	LIBRARY_API: {
		GET_LITERATURE_BOOK_LIST: "/midStudy/v1.0/class/ctgrTypes/{CTGR_TY}/ctgrCodes/{CTGR_CD}/users/{MMBR_SEQ}/grad/{GRAD}/prgs/{STD_PRGS_ST}/liBook/?PEDC_CD={PEDC_CD}&START_IDX={START_IDX}", // (GET) 문학도서관 도서 목록 조회
		GET_MONTH_LITERATURE_BOOK_LIST: "/midStudy/v1.0/class/ctgrTypes/{CTGR_TY}/ctgrCodes/{CTGR_CD}/users/{MMBR_SEQ}/applyBook/?GRAD={GRAD}" // (GET) 이달의 도서 목록 조회
	},

	// 문학 독후감
	BOOK_REPORT_API: {
		// 독후감 이벤트 배너 조회(GET)
		GET_BOOK_REPORT_BANNER_INFO: "/midStudy/v1.0/reportevt/todayEventCard",
		// 독후감 이벤트 기간 진행 내역 조회(GET)
		GET_BOOK_REPORT_PERIOD_INFO: "/midStudy/v1.0/reportevt/evtInfo/evt/{REPORT_EVT_SEQ}",
		// 독후감 대상 도서 목록 조회(GET)
		GET_BOOK_REPORT_BOOK_LIST: "/midStudy/v1.0/reportevt/bookList/evt/{REPORT_EVT_SEQ}",
		// 독후감 글 저장(POST)
		POST_SAVE_BOOK_REPORT: "/midStudy/v1.0/reportevt/saveReport/evt/{REPORT_EVT_SEQ}/users/{MMBR_SEQ}/book/{BOOK_SEQ}",
		// 독후감 상세 조회(GET)
		GET_BOOK_REPORT_DETAIL: "/midStudy/v1.0/reportevt/review/{REVIEW_SEQ}",
		// 나의 독후감 목록 조회(GET)
		GET_MY_REPORT_LIST: "/midStudy/v1.0/reportevt/reviewList/evt/{REPORT_EVT_SEQ}/users/{MMBR_SEQ}?PAGE_CNT={PAGE_CNT}&PAGE_SIZE={PAGE_SIZE}",
		// 독후감 회차 코드목록 조회(GET)
		GET_REPORT_EVT_CODE_LIST: "/midStudy/v1.0/reportevt/code/bookEventList",
		// 독후감 시상 목록 조회(GET)
		GET_REPORT_AWARD_LIST: "/midStudy/v1.0/reportevt/winnerList/evt/{REPORT_EVT_SEQ}"
	},

	GRADE_UPDATE_API: {
		GET_UPDATE_INFO: "/midStudy/v1.0/member/prmt/members/{MMBR_SEQ}/gradCds/{GRAD_CD}",
	},

	LOGOUT_API: {
		LOGOUT: "/common/logout"
	},

	FIND_API: {
		// 비밀번호 변경(POST)
		CHANGE_PASSWORD: "/membership/v1.0/samid/changeMmbrPswdToAuthToken",
		// 휴대폰 코드 전송(POST)
		SEND_CODE: "/membership/v1.0/samid/sendSecurityCodeId",
		// 인증코드 체크 (POST)
		CHECK_CODE: "/membership/v1.0/samid/verifySecurityCodePswd",
		// 아이디 찾기 (POST)
		FIND_ID: "/membership/v1.0/samid/findMmbrId",
	},

	// 출석체크 API
	ATTEND_API: {
		ATTEND: "/midStudy/v1.0/member/users/{MMBR_SEQ}/attend",
		POST_CHECK_POPUP: "/midStudy/v1.0/member/user/{MMBR_SEQ}/mainPopupCheck" // 출석완료팝업 활성화 저장 및 확인
	},

	ERROR_MESSAGE: {
		DUPLICATE_LOGIN: "고객님의 아이디가 다른 기기에\n 등록되어 있어 로그인이 제한됩니다.\n다른 기기에서 로그아웃하시고\n다시 시도해주세요.",
		EXPIRED_LOGIN: "로그인 정보가 만료 되었습니다.\n",
		EXPIRED_AUTOLOGIN: "자동로그인 연결이 실패하였습니다.\n다시 로그인 시도해 주세요.",
		EXPIRED_DEVICE_DATE: "로그인 정보가 만료 되었습니다.\n디바이스 날짜를 확인해주세요.",
		SLOW_NETWORK: "네트워크에 일시적인 장애가 발생했습니다.\n잠시 후 다시 시도 해주세요.",
		SERVER_ERROR: "일시적인 장애가 발생했습니다.\n잠시 후 다시 시도 해주세요.",
	},

	AIME_API: {
		//수학
		//현재 날짜 기준 시험구분코드,학기,년도
		GET_PRIDINFO: "/midStudy/v1.0/ai/gradCds/{GRAD_CD}/courseCds/{COURSE_CODE}/examPridInfo",
		//ai 학습 성취도 현황 
		GET_ACHIEVEMENT: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/courseCds/{COURSE_CODE}/years/{YR}/smsts/{SMST_CD}/examDvsns/{EXAM_DVSN_CD}/aiAchievement",
		//ai 학습 성취도 단원명 정답률 조회
		GET_UNITACHIEVEMENT: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/courseCds/{COURSE_CODE}/years/{YR}/smsts/{SMST_CD}/examDvsns/{EXAM_DVSN_CD}/qstUnitSeq/{QST_UNIT_SEQ}/aiUnitAchievement",
		//ai 정규 기간 및 수강 수
		GET_REGULARPERIOD: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/courseCds/{COURSE_CODE}/years/{YR}/smsts/{SMST_CD}/examDvsns/{EXAM_DVSN_CD}/smstPridInfo",
		//ai 추천 커리큘럼
		GET_RCMNCURRICULUM: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/years/{YR}/smsts/{SMST_CD}/aiRcmnCrcm",
		//ai 추천 커리큘럼 변경
		POST_CHGCURRICULUM: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/years/{YR}/smsts/{SMST_CD}/aiRcmnCrcmChg?PEDC_CD={PEDC_CD}",
		//ai 추천 강의
		GET_RCMNLECTURE: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/courseCds/{COURSE_CODE}/typeCds/{TYPE_CD}/aiRcmnLecture",
		//ai 리포트
		GET_AIREPORT: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/years/{YR}/smsts/{SMST_CD}/aiReport",
		//ai 시험대비 약점 공략
		GET_TESTPREPARATION: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/courseCds/{COURSE_CODE}/years/{YR}/smsts/{SMST_CD}/examDvsns/{EXAM_DVSN_CD}/testPreparation",
		//ai 최종 모의고사
		GET_PREPAREEXAM: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/courseCds/{COURSE_CODE}/years/{YR}/smsts/{SMST_CD}/examDvsns/{EXAM_DVSN_CD}/aiPrepareExam",
		//영어 문법 공략
		GET_AIENPREPARE: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/years/{YR}/smsts/{SMST_CD}/examDvsns/{EXAM_DVSN_CD}/aiEnPrepare",
		//모의고사 조회
		GET_AIENMOCKTEST: "/users/{MMBR_SEQ}/step/{STEP}/gradCds/{GRAD_CD}/years/{YR}/smsts/{SMST_CD}/examDvsns/{EXAM_DVSN_CD}/unitSeq/{UNIT_SEQ}/aiEngMockTest",
		// 모의고사
		GET_AIENEXAM: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/years/{YR}/smsts/{SMST_CD}/examDvsns/{EXAM_DVSN_CD}/unitSeq/{QST_UNIT_SEQ}/aiEnExam",
		// 문항추천
		GET_AIENRCMSTEP: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/step/{STEP}/aiConerMpgnSeq/{AI_CONER_MPNG_SEQ}/coners/{CONER_SEQ}/aiGrammStep",
		//문항조회
		GET_AIENGMQST: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/aiRcmnMstSeq/{AI_RCMN_MSTR_SEQ}/engmQst",
		// 백분율 조회
		// GET_AIENGPERCENT: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/coners/{CONER_SEQ}/aiConerMpgnSeq/{AI_CONER_MPNG_SEQ}/percentile",
		GET_AIENGPERCENT: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/coners/{CONER_SEQ}/gradCds/{GRAD_CD}/years/{YR}/smsts/{SMST_CD}/examDvsns/{EXAM_DVSN_CD}/percentile",
		// 문항 초기화: 쌍둥이/유사/한수준위 응시 중단한 케이스일 때, 문제은행 서비스를 메타수학에서 에듀베이스로 재설정
		DELETE_AIREPORT_EXAM: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/courseCds/{COURSE_CODE}/years/{YR}/smsts/{SMST_CD}/tcmtCd/{TCMT_DVSN_CD}/qstUnitSeq/{QST_UNIT_SEQ}/aiTcmtUnitRcmnQst",
		// AI수학 커리큘럼 추천 조회 (GET)
		GET_RCMNCURRICULUMCNT: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/years/{YR}/smsts/{SMST_CD}/aiRcmnCrcmShst",
		// 2024 Ai 수학 고도화 초기 데이터
		GET_AIINITDATA: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/aiInitData",
		// AI리포트
		GET_AIREPORTANALY: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/courseCds/MATH/aiReportAnaly",
		// AI리포트 학습기록 리스트 (GET	)
		GET_AIREPORTLIST: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/courseCds/MATH/aiAddCurrCosLec",
		// 단원별 AI 추천 문항
		GET_AIUNITRCMMRSINFO: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/courseCds/MATH/gradCds/{GRAD_CD}/smsts/{SMST_CD}/types/AI_UNIT_RCMN/aiUnitRcmmRsInfo",
		// 시험대비 AI 집중공략
		GET_AITOPICRCMMRSINFO: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/courseCds/MATH/gradCds/{GRAD_CD}/smsts/{SMST_CD}/examDvsnCd/{EXAM_DVSN_CD}/types/AI_PRE_WEEK/aiTopicRcmmRsInfo",
		// AI 수학 시험 가데이터
		GET_UNIT_RCMN_QST: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/courseCds/MATH/gradCds/{GRAD_CD}/smsts/{SMST_CD}/types/{TYPES}/qstUnitSeq/{QST_UNIT_SEQ}/aiUnitRcmmQueInfo",
		// 문항 저장 (POST)
		SAVE_EXAM_PLAYER: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/courseCds/MATH/qstUnitSeq/{QST_UNIT_SEQ}/trkSeq/{TRK_SEQ}/types/{TYPES}/aiRcmnQueUpd",
		// 문항 저장 Final (POST)
		SAVE_EXAM_LAST: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/trkSeq/{TRK_SEQ}/aiRcmnQueLtSave",
		// 단원 설정하기 (GET)
		GET_UNIT_SETTING: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/smsts/{SMST_CD}/examDvsnCd/{EXAM_DVSN_CD}/types/AI_PRE_WEEK/aiUnitMmbrSetInfo",
		// 단원 설정하기 (POST)
		SET_UNIT_SETTING: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/smsts/{SMST_CD}/examDvsnCd/{EXAM_DVSN_CD}/types/AI_PRE_WEEK/aiUnitMmbrSet",
		// 분석지 (GET)
		GET_ANALYZE_INFO: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/types/{EXAM_DVSN_CD}/qstUnitSeq/{QST_UNIT_SEQ}/aiRcmnAnalyList",
		// 오답노트 날짜 호출 (GET)
		GET_WNOTE_DATES: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/qstUnitSeq/{QST_UNIT_SEQ}/aiRcmnWransrDates",
		// 오답노트 리스트 (GET)
		GET_WNOTE_LIST: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/qstUnitSeq/{QST_UNIT_SEQ}/aiRcmnWransrList",
		// 진단평가 문항 조회/저장 (POST)
		SAVE_EVAL_EXAM: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/smsts/{SMST_CD}/examSeq/{ABLITY_EXAM_SEQ}/aiAblityExamQstInfo",
		// 신규 진단평가 성적표 (GET)
		GET_EVALUATION_REPORT: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/smsts/{SMST_CD}/examSeq/{EXAM_SEQ}/diagSeq/{DIAG_SEQ}/aiRepResProcess",
		// 오답노트 채점하기 (POST)
		SAVE_WNOTE_EXAM: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/qstUnitSeq/{QST_UNIT_SEQ}/qstCd/{QST_CD}/aiRcmnWransrSet"
	},

	AI_ENGLISH_API: {
		// 모의고사 문제 리스트(GET)
		GET_MOCK_QST_LIST: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/step/{STEP}/aiRcmnMstrSeq/{AI_RCMN_MSTR_SEQ}/unitSeq/{UNIT_SEQ}/examDvsns/{EXAM_DVSN_CD}/aiMocQst",
		// 모의고사 정보(GET)
		GET_MOCK_INFO: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/step/{STEP}/gradCds/{GRAD_CD}/years/{YEAR}/smsts/{SMST_CD}/examDvsns/{EXAM_DVSN_CD}/unitSeq/{UNIT_SEQ}/aiEngMockTest",
		// 단원평가 ai 문제 리스트 (GET)
		GET_QST_B_LIST: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/aiRcmnMstSeq/{AI_RCMN_MSTR_SEQ}/engmQst",
		// 단원평가 ai 문제 생성(GET)
		PUT_QST_B_LIST: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/step/{STEP}/aiConerMpgnSeq/{AI_CONER_MPNG_SEQ}/coners/{CONER_SEQ}/stdTyDvsnCds/{STD_TY_DVSN_CD}/aiGrammStep",
		// PUT_QST_B_LIST: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/step/{STEP}/aiConerMpgnSeq/{AI_CONER_MPNG_SEQ}/coners/{CONER_SEQ}/stdTyDvsnCds/AI_EN_RUL_GRMR_STD/aiGrammStep",

		// AI 영어 정규
		// AI 영어 정규 - 커리큘럼 정보 , 단원 정보 조회 (GET)
		GET_REGULAR_INFO: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/years/{YR}/smsts/{SMST_CD}/aiEnRegularInfo",
		// AI 영어 정규 - 단원코드로 강의정보 조회 (GET)
		GET_LECTURE_INFO: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/years/{YR}/smsts/{SMST_CD}/unitSeq/{UNIT_SEQ}/aiEnRegularConerInfo",
		// AI 영어 정규 - 리포트 정보 조회  (GET)
		GET_AIENREPORT: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/years/{YR}/smsts/{SMST_CD}/aiEnReport",
		// AI 영어 정규 - 진단평가 완료 후 내 실력 이력 저장 (GET)
		GET_AIENSAVEPRED: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/years/{YR}/smsts/{SMST_CD}/aiEnSavePrediction",
		// AI 영어 정규 - 모의고사 완료 후 이력 저장 (GET)
		GET_AIENSAVEMOCK : "/midStudy/v1.0/ai/users/{MMBR_SEQ}/gradCds/{GRAD_CD}/years/{YR}/smsts/{SMST_CD}/aiEnSaveMock",
		// AI 영어 영상 중간저장
		POST_AIEN_VOD_SAVE: "/midStudy/v1.0/ai/users/{MMBR_SEQ}/aiConerMpgnSeq/{AI_CONER_MPNG_SEQ}/aiEnVodShstIns",
	},

	All_TAB_API: {
		GET_CARD_INFO: "/midStudy/alltab/today/members/{MEMBER_CODE}/contracts/{CONTRACT_NUMBER}", //과외방 과목카드
		GET_SUBJECTS_LIST: "/midStudy/alltab/today/courseTabList/member/{MEMBER_CODE}/contracts/{CONTRACT_NUMBER}", // TAB 과목 리스트
		GET_CURRENT_CLASS_INFO: "/midStudy/alltab/today/class/cur/members/{MEMBER_CODE}/contracts/{CONTRACT_NUMBER}/orders/{ORDER_SEQ}?COURSE_CODE={COURSE_CODE}", //현재 수업 정보
		GET_REVIEW_CLASS_LIST: "/midStudy/alltab/today/coaching/members/{MEMBER_CODE}/contracts/{CONTRACT_NUMBER}/orders/{ORDER_SEQ}", //수업 리뷰 코칭 모든 회차 리스트
		GET_REVIEW_INFO: "/midStudy/alltab/today/coaching/members/{MEMBER_CODE}/schedules/{SCHEDULE_SEQ}/contracts/{CONTRACT_NUMBER}", //수업 리뷰 코칭 회차별 조회
		GET_CALENDAR_LIST: "/midStudy/alltab/today/calendar/members/{MEMBER_CODE}/year/{YEAR}/month/{MONTH}/contracts/{CONTRACT_NUMBER}", //학습 캘린더
		GET_ENTRANCE: "/midStudy/alltab/today/entry/members/{MEMBER_CODE}/schedules/{SCHEDULE_SEQ}/contracts/{CONTRACT_NUMBER}",//방 입장
		GET_HOMEWORK_ALLCNT: "/midStudy/alltab/today/coaching/homework/allcnt/members/{MEMBER_CODE}/contracts/{CONTRACT_NUMBER}", // 메인 화면용 전체 숙제 갯수 조회
		GET_HOMEWORK_CURCNT: "/midStudy/alltab/today/coaching/homework/curcnt/members/{MEMBER_CODE}/contracts/{CONTRACT_NUMBER}", // 과목별 숙제 갯수 조회
		GET_HOMEWORK_CONTRACT_ORDERS_DEV: "/midStudy/alltab/today/coaching/members/{MEMBER_CODE}/contracts/{CONTRACT_NUMBER}/orders/{ORDER_SEQ}", // 수업 리뷰 코칭 모든 회차 리스트(DEV)
		GET_HOMEWORK_SCHEDULES_CONTRACTS: "/midStudy/alltab/today/coaching/members/{MEMBER_CODE}/schedules/{SCHEDULE_SEQ}/contracts/{CONTRACT_NUMBER}", // 수업 리뷰 코칭 회차별 조회(DEV)
		GET_HOMEWORK_UPDATE_HW_PROC: "/midStudy/alltab/today/coaching/homework/updateHwProc/hwSeq/{HW_SEQ}/members/{MEMBER_CODE}/contracts/{CONTRACT_NUMBER}", // 숙제 제출
		GET_HOMEWORK_LECTURE: "/midStudy/v1.0/class/users/{MMBR_SEQ}/classDetailAlltab?LEC_SEQ={LEC_SEQ}",
		GET_HOMEWORK_FILE_UPLOAD: "/midStudy/alltab/today/coaching/homework/uploadHomeWorkFile/ymd/{YMD}/scheduleTime/{SCHEDULE_TIME}", // 숙제 파일 업로드
		GET_LEARNING_MATE: "/midStudy/alltab/today/coaching/mate/selectInfo/members/{MEMBER_CODE}/categoryCd/{CATEGORY_CD}", // 올탭과외 러닝메이트 이벤트 신청 이력 조회
		POST_LEARNING_MATE: "/midStudy/alltab/today/coaching/mate/register", // 올탭과외 러닝메이트 이벤트 신청
		POST_LEARNING_FILE_UPLOAD: "/midStudy/alltab/today/coaching/mate/uploadHomeWorkFile", // 올탭과외 러닝메이트 파일 업로드
	},

	//로그인 이력 조회 api
	POPUP_LOGIN_API: {
		GET_POPUP_INFO: "/midStudy/v1.0/common/ppupInfo/users/{MMBR_SEQ}/ppupSeq/{POPUP_SEQ}",
		GET_POPUP_SUCCESS: "/midStudy/v1.0/common/ppupInfo/users/{MMBR_SEQ}/ppupSeq/{POPUP_SEQ}/ppupHstInsert",
	},
	// 로그인 시 학년 변경 체크 API
	SET_GRADE_API: {
		GET_GRADE_INFO: "/midStudy/v1.0/member/user/{MMBR_SEQ}/getGradCd",
	},
	// 신규 홈(AllNewStudyToday) API
	NEW_MAIN_API: {
		// 주간 계획학습 시간표 + 별(리워드) 개수 + 알림함 개수
		WEEK_PLAN_TMTBL: "/midStudy/v1.0/main/week/plan/tmtbl?MMBR_SEQ={MMBR_SEQ}&TODAY={TODAY}&PEDC_CD={PEDC_CD}",
		// 매일루틴 (찜한 강좌 / AI독서실 / 올백TEST)
		DAILY_ROUTINE: "/midStudy/v1.0/main/daily/routine?MMBR_SEQ={MMBR_SEQ}&TODAY={TODAY}&PEDC_CD={PEDC_CD}",
	},

	// 성적우수장학생 API
	REWARD_API: {
		GET_REWARD_INFO: "/midStudy/v1.0/scholarship/home/info/mmbrSeqs/{MMBR_SEQ}",
		GET_QUALIFICATION_INFO: "/midStudy/v1.0/scholarship/home/qualification/mmbrSeqs/{MMBR_SEQ}/lmttDt/{LMTT_DT}",
		GET_RECEIPT_STEP1: "/midStudy/v1.0/scholarship/receipt/step1/mmbrSeqs/{MMBR_SEQ}/ctgrSeq/{CTGR_SEQ}",
		POST_SAVE_STEP1: "/midStudy/v1.0/scholarship/receipt/step1/mmbrSeqs/{MMBR_SEQ}/ctgrSeq/{CTGR_SEQ}/awardSeq/{AWARD_SEQ}/agreeYn/{AGREE_YN}/gradCd/{GRAD_CD}",
		GET_RECEIPT_STEP2: "/midStudy/v1.0/scholarship/receipt/step2/mmbrSeqs/{MMBR_SEQ}/ctgrSeq/{CTGR_SEQ}/aplnSeq/{APLN_SEQ}",
		POST_SAVE_STEP2: "/midStudy/v1.0/scholarship/receipt/step2/mmbrSeqs/{MMBR_SEQ}/ctgrSeq/{CTGR_SEQ}/aplnSeq/{APLN_SEQ}/koMScore/{KO_M_SCORE}/enMScore/{EN_M_SCORE}/maMScore/{MA_M_SCORE}/soMScore/{SO_M_SCORE}/scMScore/{SC_M_SCORE}/histMScore/{HIST_M_SCORE}/koEScore/{KO_E_SCORE}/enEScore/{EN_E_SCORE}/maEScore/{MA_E_SCORE}/soEScore/{SO_E_SCORE}/scEScore/{SC_E_SCORE}/histEScore/{HIST_E_SCORE}/mdleAvgScore/{MDLE_AVG_SCORE}/eoftAvgScore/{EOFT_AVG_SCORE}?SMST_CD={SMST_CD}&GRAD_CD={GRAD_CD}",
		GET_RECEIPT_STEP3: "/midStudy/v1.0/scholarship/receipt/step3/mmbrSeqs/{MMBR_SEQ}/ctgrSeq/{CTGR_SEQ}/aplnSeq/{APLN_SEQ}",
		POST_SAVE_STEP3: "/midStudy/v1.0/scholarship/receipt/step3/mmbrSeqs/{MMBR_SEQ}/ctgrSeq/{CTGR_SEQ}/aplnSeq/{APLN_SEQ}/yr/{YR}/fileDvsn/{FILE_DVSN}/examDvsnCd/{EXAM_DVSN_CD}/awardSeq/{AWARD_SEQ}",
		GET_RECEIPT_STEP4: "/midStudy/v1.0/scholarship/receipt/step4/mmbrSeqs/{MMBR_SEQ}/ctgrSeq/{CTGR_SEQ}/aplnSeq/{APLN_SEQ}",
		POST_SAVE_STEP4: "/midStudy/v1.0/scholarship/receipt/step4/mmbrSeqs/{MMBR_SEQ}/ctgrSeq/{CTGR_SEQ}/aplnSeq/{APLN_SEQ}",
		DELETE_STEP3_DATA: "/midStudy/v1.0/scholarship/receipt/step3/mmbrSeqs/{MMBR_SEQ}/ctgrSeq/{CTGR_SEQ}/aplnSeq/{APLN_SEQ}/fileSeq/{FILE_SEQ}",
		GET_REVIEW_CATEGORY: "/midStudy/v1.0/scholarship/category/list",
		GET_REVIEW_AWARD: "/midStudy/v1.0/scholarship/ctgrAwardList/ctgrSeq/{CTGR_SEQ}",
		GET_REVIEW_LIST: "/midStudy/v1.0/scholarship/reviewList/ctgrSeq/{CTGR_SEQ}/awardSeq/{AWARD_SEQ}",
		GET_REVIEW_DETAIL: "/midStudy/v1.0/scholarship/reviewInfo/trscCnttSeq/{TRSC_CNTT_SEQ}"
	},
	// 초등 -> 중학 약관변경
	TRANSFER: {
		GET_TRANSFER_LIST: `/membership/v1.0/samid/transfer/members?MMBR_NAME={MMBR_NAME}&YEAR={YEAR}&MONTH={MONTH}&SUBSCRIBER_TYPE={SUBSCRIBE_TYPE}&AGREE={AGREE}`,
		POST_TRANSFER_INFO: "/membership/v1.0/samid/transfer/contracts/{CONTRACT_NUMBER}/members/{CUSTOMER_NUMBER}",
	},

	// 올탭 집합형 이용권 목록
	STUDY_ROOM_LIST: [
	
		"PEDC-00005",
		"PEDC-00006",
		"PEDC-00007",
		"PEDC-00008",
		"PEDC-00010",
		"PEDC-00011",
		"PEDC-00014",
		"PEDC-00015",
		"PEDC-00016",
	],

	// 이용권 목록
	MEMBERSHIP_LIST: {
		ALTB: {
			ENGM: "PEDC-00028", // 영어
			MATH: "PEDC-00029", // 수학
			SCNE: "PEDC-00030", // 과학
		}, // 올탭 단과목(영/수/과)
		LTAL: "PEDC-00027",	// 라이트형 이용권
		
	}, 

	// 소팅 목록
	SORT_LIST: [
		{
			CODE: "ALL",
			CODE_NAME: "가나다순",
		},
		{
			CODE: "REG",
			CODE_NAME: "등록순",
		},
	],
};

export default Constants;
